module.exports = __webpack_public_path__ + "6b3f370fb3715ab34243db8064a3805b.svg";